<template>
    <div v-if="userAttribute != null">
        <el-tabs v-if="showTab" v-model="selectedTabName" type="border-card" @tab-click="handleChangeTab" :before-leave="beforeLeave">
            <el-tab-pane :label="$t('message.title_user_information')" name="userInfo"></el-tab-pane>
            <el-tab-pane v-if="!isAdminUser" :label="$t('message.title_userGroup')" name="userGroup"></el-tab-pane>

            <template v-if="selectedTabName=='userInfo'">

                <template v-if="isAdminUser">
                    <div class="object-titlebox">
                        <div class="object-titlebox-right">
                            <template v-if="showMoveUserCommand">
                                <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('MoveUser')"><img src="../../../../assets/move.svg"/><span class="normal-command-text" v-t="'message.common_action_move'"></span></button>
                            </template>
                            <template v-if="showEditUserCommand">
                                <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('EditUser')"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                            </template>
                        </div>
                    </div>
                    <table width=100%>
                        <tr class="objectitem-record"><td class="object-item" v-t="'message.item_userId'"></td><td class="object-value">{{ userAttribute.name }}</td></tr>
                        <tr class="objectitem-record"><td class="object-item" width=50%  v-t="'message.item_userDisplayName'"></td><td class="object-value">{{ userAttribute.displayName }}</td></tr>
                    </table>
                </template>

                <template v-else>
                    <div class="object-titlebox">
                        <div class="object-titlebox-right">
                            <button class="transparent-button" type="button" v-on:click="showCreateToken=true"><img src="../../../../assets/icon_lock.svg"/><span class="normal-command-text" v-t="'message.action_create_token'"></span></button>
                            <button class="transparent-button" type="button" v-on:click="forceLogoutConfirmUser()"><img src="../../../../assets/icon_force_logout.svg"/><span class="important-command-text" v-t="'message.action_force_logout'"></span></button>
                            <template v-if="showDeleteUserCommand">
                                <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('DeleteUser')"><img src="../../../../assets/delete.svg"/><span class="important-command-text" v-t="'message.common_action_delete'"></span></button>
                            </template>
                            <template v-if="showMoveUserCommand">
                                <button v-if="!tableView" class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('MoveUser')"><img src="../../../../assets/move.svg"/><span class="normal-command-text" v-t="'message.common_action_move'"></span></button>
                            </template>
                            <template v-if="showEditUserCommand">
                                <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('EditUser')"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                            </template>
                        </div>
                    </div>
                    <table width=100%>
                        <tr class="objectitem-record"><td class="object-item" v-t="'message.item_userId'"></td><td class="object-value">{{ userAttribute.name }}</td></tr>
                        <tr class="objectitem-record"><td class="object-item" v-t="'message.item_login_id'"></td><td class="object-value">{{ userAttribute.name }}@{{appData.tenantList[0].name}}</td></tr>
                        <tr class="objectitem-record"><td class="object-item" width=50%  v-t="'message.item_userDisplayName'"></td><td class="object-value">{{ userAttribute.displayName }}</td></tr>
                        <tr class="objectitem-record"><td class="object-item" v-t="'message.item_organization'"></td><td class="object-value">{{ userAttribute.organization }}</td></tr>
                        <tr class="objectitem-record"><td class="object-item" v-t="'message.item_job_title'"></td><td class="object-value">{{ userAttribute.title }}</td></tr>
                        <tr class="objectitem-record"><td class="object-item" v-t="'message.item_tenant_phone'"></td><td class="object-value">{{ userAttribute.phoneNumber }}</td></tr>
                        <tr class="objectitem-record"><td class="object-item" v-t="'message.item_tenant_email'"></td><td class="object-value">{{ userAttribute.emailAddress }}</td></tr>
                        <tr class="objectitem-record">
                            <td class="object-item" v-t="'message.item_option_easyLogin'"></td>
                            <td v-if="userAttribute.userOptions.easyLogin" class="object-value" v-t="'message.item_value_used'"></td>
                            <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                        </tr>
                        <tr class="objectitem-record">
                            <td class="object-item" v-t="'message.item_option_easyLogin_QR'"></td>
                            <td v-if="userAttribute.userOptions.showGroupUrl" class="object-value" v-t="'message.item_value_used'"></td>
                            <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                        </tr>
                        <tr class="objectitem-record">
                            <td class="object-item" v-t="'message.item_option_interrupt_permission'"></td>
                            <td v-if="userAttribute.userOptions.interrupt" class="object-value" v-t="'message.value_present'"></td>
                            <td v-else class="object-value" v-t="'message.value_absent'"></td>
                        </tr>
                        <tr class="objectitem-record">
                            <td class="object-item" v-t="'message.item_option_map_talk'"></td>
                            <td v-if="userAttribute.userOptions.mapTalk" class="object-value" v-t="'message.item_value_used'"></td>
                            <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                        </tr>
                        <tr v-if="showOptionSetting" class="objectitem-record">
                            <td class="object-item" v-t="'message.item_option_speechToText'"></td>
                            <td v-if="userAttribute.userOptions.speechToText" class="object-value" v-t="'message.item_value_used'"></td>
                            <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                        </tr>
                        <tr v-if="showOptionSetting" class="objectitem-record">
                            <td class="object-item" v-t="'message.item_option_translation'"></td>
                            <td v-if="userAttribute.userOptions.translation" class="object-value" v-t="'message.item_value_used'"></td>
                            <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                        </tr>
                        <tr v-if="isVisibleUserOption('tracking')" class="objectitem-record">
                            <td class="object-item" v-t="'message.item_option_location_tracking'"></td>
                            <td v-if="userAttribute.userOptions.tracking" class="object-value" v-t="'message.item_value_used'"></td>
                            <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                        </tr>
                        <tr v-if="isVisibleUserOption('video')" class="objectitem-record">
                            <td class="object-item" v-t="'message.item_option_video'"></td>
                            <td v-if="userAttribute.userOptions.video" class="object-value" v-t="'message.item_value_used'"></td>
                            <td v-else class="object-value" v-t="'message.item_value_nonUsed'"></td>
                        </tr>
                        <tr v-if="isTwoPhaseMethodActive()" class="objectitem-record">
                            <td class="object-item"> <!-- v-t="'message.item_confirmation_code_notice'" -->
                                <span>{{getMessageText('item_confirmation_code_notice')}}</span>
                                <template v-if="showEditUserCommand">
                                    <button class="transparent-button" type="button" v-on:click="showDialogAfterWritableCheck('EditTwoPhaseMethod')"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                                </template>
                            </td>
                            <td v-if="isUserTwoPhaseMethodReady()" class="object-value">{{showTwoPhaseMethod(userAttribute.twoPhaseMethod)}}</td>
                            <td v-else class="object-value" v-t="'message.item_value_notSet'"></td>
                        </tr>
                    </table>
                    <div class="object-titlebox">
                        <div class="object-titlebox-left">
                            <span>{{ $t('message.item_detailed_information') }}</span>
                        </div>
                    </div>
                    <table width=100%>
                        <tr class="objectitem-record">
                            <td class="object-item" style="width: 50%">
                                <spn>{{ $t('message.item_usage_status') }}</spn>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_usage_status')"/>
                                    <img class="icon-help" style="height:15px" :src="require('@/assets/icon_help.svg')" alt=""/>
                                </el-tooltip>
                            </td>
                            <td class="object-value">{{ useStatus }}</td>
                        </tr>
                        <tr class="objectitem-record">
                            <td class="object-item" style="width: 50%">
                                <spn>{{ $t('message.item_use_start_date') }}</spn>
                            </td>
                            <td class="object-value">{{ useStartDate }}</td>
                        </tr>
                    </table>
                </template>

            </template>

            <!-- タブ : 参加できるグループ -->
            <template v-else-if="selectedTabName=='userGroup'">
                <div class="object-titlebox">
                    <div class="object-titlebox-left" v-t="{ path: 'message.title_groupOfUser', args: { name: userAttribute.displayName, groupCount: groupCount} }"></div>
                    <div class="object-titlebox-right">
                        <div v-if="talkGroupUsers.length==0">
                            <template v-if="showEditUserGroupCommand">
                                <button class="transparent-button" type="button" @click="showDialogAfterWritableCheck('AddTalkGroupToUser')"><img src="../../../../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_group_to_user'"></span></button>
                            </template>
                        </div>
                        <div v-else>
                            <template v-if="showEditUserGroupCommand">
                                <button class="transparent-button" type="button" @click="showDialogAfterWritableCheck('AddTalkGroupToUser')"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.action_edit_group_of_user'"></span></button>
                            </template>
                        </div>
                    </div>
                    <el-form @submit.native.prevent="submit">
                        <el-input :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" class="object-search-select" style="width:540px;" clearable @clear="clearSearchString()" :disabled="userSearchDisabled" >
                            <el-select class="search-item" v-model="condition" slot="prepend" @change="handleChangeSearchCondition()">
                                <el-option :label="$t('message.item_display_all')" value="all"></el-option>
                                <el-option :label="$t('message.item_groupId')" value="name"></el-option>
                                <el-option :label="$t('message.item_mandatory_yes')" value="mandatoryYes"></el-option>
                                <el-option :label="$t('message.item_mandatory_no')" value="mandatoryNo"></el-option>
                            </el-select>
                            <el-button class="search-button" slot="append" @click="filterTalkGroup()" v-t="'message.action_filter_items'"></el-button>
                        </el-input>
                    </el-form>
                </div>
                <div v-if="(loadingScreen == null) && usersTalkGroupExceededMax" class="object-titlebox">
                    <div class="error-message-text" v-t="{ path: 'message.info_exceeds_group_count', args: { count: talkGroupUsers.length } }"></div>
                </div>
                <table width=100% cellpadding=0 cellspacing=0>
                    <tr class="talkgroup-title">
                        <td class="talkgroup-item-header1" v-t="'message.item_groupId'"></td>
                        <td class="talkgroup-item-header2" style="white-space: pre-wrap;" v-t="'message.title_default_talk_group'"></td>
                        <td class="talkgroup-item-header2" v-t="'message.title_mandatory'"></td>
                        <td class="talkgroup-item-header2" style="white-space: pre-wrap;" v-t="'message.title_default_second'"></td>
                        <td v-if="enableSafetySupport" class="talkgroup-item-header2" style="white-space: pre-wrap;" v-t="'message.title_voice_report_group'"></td>
                        <td v-if="showDeleteUserGroupCommand" class="talkgroup-item-header2" v-t="'message.common_action_delete'"></td>
                    </tr>
                    <tr class="talkgroup-item-record" v-for="(userTalkGroup,index) in talkGroupUsers">
                        <td v-if="userTalkGroup.userTenantId == userTalkGroup.tenantId" class="talkgroup-item1">{{ userTalkGroup.talkgroupName }}</td>
                        <td v-else class="talkgroup-item1">{{ userTalkGroup.talkgroupName }}( {{ userTalkGroup.talkgroupTenantName }} )</td>
                        <td class="talkgroup-item2">
                            <!--input v-if="userTalkGroup.defaultFlag == 1" type="radio" name="defaulttalkgroup" :value="userTalkGroup.id" id="defaultChecked" checked="checked" @click="changeDefaultTalkgroup(userTalkGroup)">
                            </input-->
                            <input v-if="showDefaultGroup" class="action-radio-input" type="radio" :id="'userTalkGroup-' + userTalkGroup.id" name="defaulttalkgroup" :value="userTalkGroup.id" :disabled="appData.csvProcessing || !showEditUserGroupCommand" :checked="userTalkGroup.defaultFlag == 1 ? 'checked' : ''" @click="changeDefaultTalkgroup(userTalkGroup)">
                            </input>
                        </td>
                        <td class="talkgroup-item2">
                            <label>
                                <input type="hidden" name="mandatory" :value="userTalkGroup.mandatoryFlag" />
                                <input class="custom-checkbox-input" name="mandatory" value="True" type="checkbox">
                                <span v-if="userTalkGroup.mandatoryFlag">
                                    <img class="action-icon" :class="{ 'action-icon-disabled': !showEditUserGroupCommand }" src="../../../../assets/icon_check_green.svg" @click="handleChangeMandatory(userTalkGroup)"/>
                                </span>
                                <span v-else>
                                    <img class="action-icon" :class="{ 'action-icon-disabled': !showEditUserGroupCommand }" src="../../../../assets/icon_check_gray.svg" @click="handleChangeMandatory(userTalkGroup)"/>
                                </span>
                            </label>
                        </td>
                        <td class="talkgroup-item2">
                            <input v-if="showDefaultSecondGroup" class="action-radio-input" type="radio" :id="'userTalkGroup-' + userTalkGroup.id" name="defaultsecondgroup" :value="userTalkGroup.id" :disabled="appData.csvProcessing || !showEditUserGroupCommand" :checked="userTalkGroup.defaultSecondFlag == 1 ? 'checked' : ''" @click="changeDefaultSecondGroup(userTalkGroup)" />
                        </td>
                        <td v-if="enableSafetySupport" class="talkgroup-item2">
                            <input v-if="showVoiceReportGroup" type="radio" :id="'userTalkGroup-' + userTalkGroup.id" name="voicereportgroup" :value="userTalkGroup.id" :disabled="appData.csvProcessing || (userTalkGroup.optionFlag & (1 << constants.TALKGROUP_OPTION_FLAG_LONG_TALKGROUP)) !== 0" :checked="userTalkGroup.voiceReportFlag ? 'checked' : ''" @click="changeVoiceReportGroup(userTalkGroup)" />
                        </td>
                        <td v-if="showDeleteUserGroupCommand" class="talkgroup-item2">
                            <button class="item-record-button" @click="removeTalkGroup(index)"type="button"><img src="../../../../assets/icon_delete_user.svg"/></button>
                        </td>
                    </tr>
                </table>
            </template>

        </el-tabs>
        <force-logout v-if="showForceLogoutUser && selectedNode.node.data.type === 1" :confirmInfo="confirmInfo" @logout="forceLogoutUser" @cancel="showForceLogoutUser=false"></force-logout>
        <deleteuser v-if="showDeleteUser" :confirmInfo="confirmInfo" @delete="deleteUser" @cancel="showDeleteUser=false"></deleteuser>
        <deletetalkgroup v-if="showDeleteTalkGroup" :confirmInfo="confirmInfo" @delete="removeFromTalkGroup" @cancel="showDeleteTalkGroup=false"></deletetalkgroup>
        <moveuser v-if="showMoveUser" :appData="appData" @move="moveUser" :sourceObjectId="userAttribute.id" @cancel="showMoveUser=false"></moveuser>
        <edituser v-if="showEditUser" :appData="appData" :userAttribute="userAttribute" :talkgroupInfos="talkGroupUsers" :isAdminUser="isAdminUser"@save="modifyUser" @cancel="showEditUser=false"></edituser>
        <addTalkgroupToUser v-if="showAddTalkGroupToUser" :appData="appData" :userAttribute="userAttribute" @save="updateTalkgroupUsersAfterDisappearDialog" @cancel="showAddTalkGroupToUser=false"></addTalkgroupToUser>
        <editTwoPhaseMethod v-if="showEditTwoPhaseMethod" :appData="appData" :userAttribute="userAttribute" @save="updateTwoPhaseMethod" @cancel="showEditTwoPhaseMethod=false"></editTwoPhaseMethod>
        <CreateToken v-if="showCreateToken" :appData="appData" :userAttribute="userAttribute" @cancel="showCreateToken=false"></CreateToken>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import ForceLogout from "../../../ForceLogout.vue";
import DeleteObject from "../../../DeleteObject.vue";
import MoveUser from "../../../MoveObject.vue";
import EditUser from "../../../EditUser.vue";
import AddTalkgroupToUser from "../../../AddTalkgroupToUser.vue";
import EditTwoPhaseMethod from "../../../EditTwoPhaseMethod.vue"
import CreateToken from "../../../CreateToken.vue";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';

export default {
    components: {
        ForceLogout,
        deleteuser: DeleteObject,
        deletetalkgroup: DeleteObject,
        moveuser: MoveUser,
        edituser: EditUser,
        addTalkgroupToUser: AddTalkgroupToUser,
        editTwoPhaseMethod: EditTwoPhaseMethod,
        CreateToken
    },

    props: {
        selectedNode: Object,
        appData: Object,
        listType: Number,
        tableView: {
            type: Boolean,
            default: false
        },
    },

    data() {
      return {
        MAX_USER_TALKGROUP_COUNT: 500,
        showDefaultGroup: true,
        showDefaultSecondGroup: true,
        showCreateToken: false,
        showVoiceReportGroup: true,
        showForceLogoutUser: false,
        showDeleteUser: false,
        showMoveUser: false,
        showEditUser: false,
        showAddTalkGroupToUser: false,
        showDeleteTalkGroup: false,
        showEditTwoPhaseMethod: false,
        showTab: true,
        confirmInfo: {
            objectName: null,
            objectTitle: null
        },
        groupCount: 0,
        usersTalkGroupExceededMax: false,
        userOptions: [],
        userAttribute: null ,
        talkGroupUsers: [],
        defaultTalkGroup: {tenantId: 0 , talkGroupId: 0 },
        defaultSecondGroup: {tenantId: 0 , talkGroupId: 0 },
        removeTalkGroupIndex: 0,
        searchString: null,
        loadingScreen: null,
        condition: "all",
        selectedTabName: null,
        isAdminUser: false
      };
    },

    computed: {
        constants() {
            return constants
        },
        showOptionSetting: function() {
            if (this.appData.onlinePurchase) {
                if ((this.appData.enableSpeechTextOption) || (this.appData.enableSpeechTextTrial)) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },

        useStatus() {
            if (this.userAttribute.existsToken) {
                return commonUtil.getMessageText(this.$i18n, 'item_in_use');
            } else {
                return commonUtil.getMessageText(this.$i18n, 'item_in_use_not');
            }
        },

        useStartDate() {
            if (this.userAttribute.existsToken) {
                const releaseDate = new Date(Date.UTC(2021, 9, 14, 18, 0, 0))
                const tokenCreateDate = new Date(this.userAttribute.tokenCreateDate)
                if (releaseDate > tokenCreateDate) {
                    return commonUtil.getMessageText(this.$i18n, 'info_no_available_use_start_date');
                }

                return tokenCreateDate.toLocaleString()
            } else {
                return '-'
            }
        },

        enableSafetySupport() {
            return this.appData.enableSafetySupport || this.appData.enableSafetySupportTrial;
        },
        showDeleteUserCommand() {
            return commonUtil.canManageConsoleUserGroupDefinition(this.appData);
        },
        showMoveUserCommand() {
            return commonUtil.canManageConsoleUserGroupDefinition(this.appData);
        },
        showEditUserCommand() {
            return commonUtil.canManageConsoleUserGroupDefinition(this.appData);
        },
        showEditUserGroupCommand() {
            return commonUtil.canManageConsoleUserTalkgroupAssignment(this.appData);
        },
        showDeleteUserGroupCommand() {
            return commonUtil.canManageConsoleUserTalkgroupAssignment(this.appData);
        },
    },

    watch: {
        selectedNode: {
            handler(newVal, oldVal) {
                return this.getInfo();
            }
        },
        'appData.onlinePurchase'(newVal) {
            this.setUserOptions(newVal);
            this.getInfo();
        }
    },

    created: function() {
        this.setUserOptions(this.appData.onlinePurchase);
        this.selectedTabName = "userInfo";
        return this.getInfo();
    },

    methods: {
        getInfo: function() {
            if (this.selectedNode == null) {
                return;
            }
            let self = this;
            this.searchString = null;
            this.userAttribute = null;
            if (this.talkGroupUsers != null) {
                this.talkGroupUsers.splice(0,this.talkGroupUsers.length)
            }
            this.defaultTalkGroup.tenantId = 0;
            this.defaultTalkGroup.talkGroupId = 0;
            this.defaultSecondGroup.tenantId = 0;
            this.defaultSecondGroup.talkGroupId = 0;
            this.usersTalkGroupExceededMax = false;

            this.showLoadingScreen();

            server.post('/getinfo', {tenantId: this.appData.tenantList[0].tenantId, id: this.selectedNode.node.data.id, maxUserTalkgroupCount: this.MAX_USER_TALKGROUP_COUNT })
                .then((res) => {
                    self.closeLoadingScreen();
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (self.selectedNode.node.parent != null
                                && self.selectedNode.node.parent.data.id != null
                                && self.selectedNode.node.parent.data.id != res.data.pid) {
                                self.nodeInfo = null;
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_moved").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                                self.$emit('refresh');
                                return;
                            }
                            if (self.tableView && self.selectedNode.node.parent != null) {
                                self.selectedNode.node.parent.data.id = res.data.pid;
                            }
                            if (res.data.talkgroups.length == 0) {
                                this.userSearchDisabled = true;
                            } else {
                                this.userSearchDisabled = false;
                            }
                            break;
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            if (self.tableView && self.selectedNode.node.parent != null) {
                                self.selectedNode.node.parent.data.id = res.data.pid;
                            }
                            self.usersTalkgroupCount = res.data.talkgroups.length
                            self.usersTalkGroupExceededMax = true;
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_read_permission_on_layer").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                            self.$emit('refresh');
                            return;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                            self.$emit('resetSelectedNode');
                            self.$emit('refresh');
                            return;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                            return;
                    }
                    self.userAttribute = res.data;
                    self.isAdminUser = self.userAttribute.restrictions != null && self.userAttribute.restrictions.includes(constants.RESTRICTION_LOGIN);
                    self.getUserTalkGroupInfo(this.loadingScreen);
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getInfo", error);
                    self.closeLoadingScreen();
                });
        },
        getUserTalkGroupInfo(message) {
            this.showLoadingScreen();
            let self = this;
            self.groupCount = 0
            self.talkGroupUsers =[];
            self.userList = {}
            self.condition = "all";
            self.searchString = null;
            server.post('/getusertalkgroupinfo', { id: this.userAttribute.id })
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.groupCount = res.data.groupCount;
                            self.usersTalkGroupExceededMax = false;
                            break;
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            self.groupCount = res.data.groupCount;
                            self.usersTalkGroupExceededMax = true;
                            break;
                        default:
                            self.closeLoadingScreen();
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getUserTalkGroupInfo").replace("{code}",res.data.status));
                            return;
                    }

                    let result = commonUtil.sortUserTalkGroup(self.appData, res.data.userTalkgroup, constants.OBJECT_TALKGROUP);
                    self.talkGroupUsers = result.sortedUserTalkGroup;
                    self.defaultTalkGroup = result.defaultTalkGroup;
                    self.defaultSecondGroup = result.defaultSecondGroup;
                    self.closeLoadingScreen();
                    if (message != null) {
                        // need to set more delay time to show the message after close loading screen.
                        commonUtil.notifyMessageWithDuration(self, message.type, message.text, 2000);
                    }
                })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "getUserTalkGroupInfo", error);
                });
        },
        modifyUser: function(input, userOptions) {
            this.$data.showEditUser = false;

            let newName = null;
            let changeCurrentLoginUserName = false;
            if (input.userName != this.userAttribute.name) {
                newName = input.userName;
                if (this.userAttribute.id == this.appData.loginUserObjectId) {
                    changeCurrentLoginUserName = true;
                }
            }
            let newDisplayName = null;
            if (input.displayName != this.userAttribute.displayName) {
                newDisplayName = input.displayName;
            }
            let newPassword = null;
            if (input.password != "") {
                newPassword = input.password;
            }
            let newOrganization = null;
            if (input.organization != this.userAttribute.organization) {
                newOrganization = input.organization;
            }
            let newTitle = null;
            if (input.title != this.userAttribute.title) {
                newTitle = input.title;
            }
            let newPhoneNumber = null;
            if (input.phoneNumber != this.userAttribute.phoneNumber) {
                newPhoneNumber = input.phoneNumber;
            }
            let newEmailAddress = null;
            if (input.emailAddress != this.userAttribute.emailAddress) {
                newEmailAddress = input.emailAddress;
            }

            if (newName == null &&
                newDisplayName == null &&
                newPassword == null &&
                newOrganization == null &&
                newTitle == null &&
                newPhoneNumber == null &&
                newEmailAddress == null &&
                userOptions == null
            ) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_change_information"));
                return;
            }

            let self = this;
            server.post(
                '/modifyuser',
                {
                    operation:
                    {
                        id: this.$data.userAttribute.id,
                        newName: newName,
                        newDisplayName: newDisplayName,
                        newPassword: newPassword,
                        newOrganization: newOrganization,
                        newTitle: newTitle,
                        newPhoneNumber: newPhoneNumber,
                        newEmailAddress: newEmailAddress,
                        newUserOptions: userOptions
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    if (changeCurrentLoginUserName) {
                        sessionStorage.setItem('loginId', newName + "@" + self.appData.loginId.split("@")[1]);
                        self.appData.loginId = sessionStorage.getItem('loginId');
                    }
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_user"));
                    if (this.listType == 0) {
                        var inputLabel = input.userName + " / " + input.displayName;
                        if (self.selectedNode.node.data.label != inputLabel) {
                            var insertData = { data :
                                                {
                                                    tenantId: self.selectedNode.node.data.tenantId,
                                                    id: self.selectedNode.node.data.id,
                                                    label: inputLabel,
                                                    type: constants.OBJECT_USER,
                                                    restrictions: self.selectedNode.node.data.restrictions,
                                                    isLeaf: true
                                                 }
                                             };
                            this.insertNewUserToTree(insertData, self.selectedNode.node.parent);
                            self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                        }
                    } else {
                        self.$emit('refresh');
                    }
                    self.getInfo();
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_duplicateId"));
                            break;
                        case constants.STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_insufficient_license"));
                            break;
                        case constants.STATUS_ERROR_OPTION_UNMATCH:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_userOption"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        case constants.STATUS_ERROR_TIMEOUT:
                            commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_process_timeout_abort"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyUser").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "modifyUser", error);
            });
        },
        forceLogoutConfirmUser: function() {
            this.confirmInfo.objectType = 1;
            this.confirmInfo.objectName = this.userAttribute.displayName;
            this.showForceLogoutUser=true;
        },
        forceLogoutUser: function() {
            this.$data.showForceLogoutUser = false;
            let self = this;
            server.post(
                '/forcelogout',
                    {
                        id: self.selectedNode.node.data.id,
                    }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_force_logout_completed"));
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_NOT_FOUND:
                        case constants.STATUS_ERROR_TALKGROUP_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_logout"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","forceLogoutUser").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "forceLogoutUser", error);
            });
        },
        deleteConfirmUser: function() {
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"item_user");
            this.confirmInfo.objectName = this.userAttribute.displayName;
            this.showDeleteUser=true;
        },
        deleteUser: function() {
            this.$data.showDeleteUser = false;
            let self = this;
            server.post(
                '/deleteuser',
                {
                    operation:
                    {
                        id: this.$data.userAttribute.id
                    }
                }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_user_delete_with_logout"));
                        if (this.listType == 0) {
                            self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                        } else {
                            self.$emit('deleted');
                        }
                        self.$emit('resetSelectedNode');
                        break;
                    case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_deleted_user"));
                        if (this.listType == 0) {
                            self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                        } else {
                            self.$emit('deleted');
                        }
                        self.$emit('resetSelectedNode');
                        break;
                    case constants.STATUS_ERROR_INVALID_PARAMETER :
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_user_root_admin"));
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_user_tenantLink_admin"));
                        break;
                    case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_already_deleted").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                        break;
                    case constants.STATUS_ERROR_USER_HAS_EXPORTED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_user_joined_other_tenant").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                        break;
                    case constants.STATUS_ERROR_STILL_ASSIGNED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_delete_group_exist_user"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","deleteUser").replace("{code}",res.data.status));
                        break;
                }
                return;
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "deleteUser", error);
            });
        },
        moveUser: function(destinationNodeId) {
            this.$data.showMoveUser = false;
            let self = this;
            server.post(
                '/move',
                {
                    operation:
                    {
                        id: this.$data.userAttribute.id ,
                        destinationId: destinationNodeId
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_moved_user"));
                    if (this.listType == 0) {
                        // this operation only performed when select the object from tree.
                        let parentNode = self.findNode(self.selectedNode.tree.$children[0].node , destinationNodeId);
                        if (parentNode != null) {
                            // parent node already loaded
                            var insertData = { data :
                                                {
                                                    tenantId: self.selectedNode.node.data.tenantId,
                                                    id: self.selectedNode.node.data.id,
                                                    label: self.selectedNode.node.data.label,
                                                    type: constants.OBJECT_USER,
                                                    restrictions: self.selectedNode.node.data.restrictions,
                                                    isLeaf: true
                                                 }
                                             };
                            this.insertNewUserToTree(insertData, parentNode);
                        }
                        self.selectedNode.node.parent.removeChild(self.selectedNode.node);
                    } else {
                        self.$emit('refresh');
                    }
                } else {
                    if ((res.data.status === constants.STATUS_ERROR_DENIED) && (self.isAdminUser)) {
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_move_consoleadmin_from_root"));
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","moveUser").replace("{code}",res.data.status));
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "moveUser", error);
            });
        },
        insertNewUserToTree(insertData , parentNode) {
            if (parentNode.childNodes.length == 0) {
                parentNode.insertChild(insertData,0)
                parentNode.expand();
                return;
            }

            var insertIndex = this.getInsertIndexOfUser(parentNode , insertData.data.label);
            if (insertIndex < 0) {
                parentNode.insertBefore(insertData,parentNode.childNodes[0]);
            } else {
                parentNode.insertAfter(insertData,parentNode.childNodes[insertIndex]);
            }
        },
        findNode(rootNode , nodeId) {
            let foundNode = null;
            if (nodeId == 1) {
                return rootNode;
            }
            for (let node of rootNode.childNodes) {
                if (node.data.id == nodeId) {
                    return node;
                }
                if (node.childNodes.length > 0) {
                    let foundNode = this.findNode(node , nodeId)
                    if (foundNode != null) {
                        return foundNode;
                    }
                }
            }
            return;
        },
        getInsertIndexOfUser: function(parentNode , insertObjectName) {
            let insertIndex = -1;
            let nodeLastIndex = -1;
            for (let i = 0 ; i < parentNode.childNodes.length ; i++) {
                if (parentNode.childNodes[i].data.type == 0) {
                    nodeLastIndex = i;
                } else if (parentNode.childNodes[i].data.type == 1) {
                    if (commonUtil.compareStringWithNumber(parentNode.childNodes[i].data.label, insertObjectName) < 0) {
                        insertIndex = i;
                    } else {
                        break;
                    }
                }
            }
            if (insertIndex == -1) {
                if (nodeLastIndex >= 0) {
                    insertIndex = nodeLastIndex;
                }
            }
            return insertIndex;
        },
        changeDefaultTalkgroup(targetUserTalkGroup) {
            let self = this;
            let parameter = { operation:
                    {
                        tenantId: targetUserTalkGroup.tenantId,
                        talkgroupId: targetUserTalkGroup.talkgroupId,
                        userTenantId: targetUserTalkGroup.userTenantId,
                        id: this.userAttribute.id
                    }
            };
            if (targetUserTalkGroup.defaultFlag == 1) {
                server.post("/resetdefaulttalkgroup", parameter)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            targetUserTalkGroup.defaultFlag = 0;
                            self.defaultTalkGroup.tenantId = 0;
                            self.defaultTalkGroup.talkGroupId = 0;
                            commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_reset_default_group"), 4000);
                            return;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeDefaultTalkgroup1").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "changeDefaultTalkgroup", error);
                });
            } else {
                if(targetUserTalkGroup.defaultSecondFlag == 1) {
                    commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"info_cannot_set_default_second_group"));
                    this.redrawDefaultGroup();
                    return;
                }
                server.post("/setdefaulttalkgroup", parameter)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            let oldDefaultTalkGroup = self.talkGroupUsers.filter(function(userTalkGroup) {
                                return userTalkGroup.defaultFlag == 1;
                            });
                            if (oldDefaultTalkGroup.length > 0) {
                                oldDefaultTalkGroup[0].defaultFlag = 0;
                            }
                            targetUserTalkGroup.defaultFlag = 1;
                            self.defaultTalkGroup.tenantId = targetUserTalkGroup.tenantId;
                            self.defaultTalkGroup.talkGroupId = targetUserTalkGroup.talkgroupId;
                            commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_change_default_group"), 4000);
                            return;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted_talkgroup"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeDefaultTalkgroup2").replace("{code}",res.data.status));
                            break;
                    }
                    this.redrawDefaultGroup();
                    return;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "changeDefaultTalkgroup", error);
                });
            }
        },
        changeDefaultSecondGroup(targetUserTalkGroup) {
            let self = this;
            let parameter = { operation:
                    {
                        tenantId: targetUserTalkGroup.tenantId,
                        talkgroupId: targetUserTalkGroup.talkgroupId,
                        userTenantId: targetUserTalkGroup.userTenantId,
                        id: this.userAttribute.id
                    }
            };
            if (targetUserTalkGroup.defaultSecondFlag == 1) {
                server.post("/resetdefaultsecondgroup", parameter)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            targetUserTalkGroup.defaultSecondFlag = 0;
                            self.defaultSecondGroup.tenantId = 0;
                            self.defaultSecondGroup.talkGroupId = 0;
                            commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_reset_default_second_group"), 4000);
                            return;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeDefaultSecondGroup1").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "changeDefaultSecondGroup", error);
                });
            } else {
                if(targetUserTalkGroup.defaultFlag == 1) {
                    commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"info_cannot_set_default_second_group"));
                    this.redrawDefaultSecondGroup();
                    return;
                }
                server.post("/setdefaultsecondgroup", parameter)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            let oldDefaultSecondGroup = self.talkGroupUsers.filter(function(userTalkGroup) {
                                return userTalkGroup.defaultSecondFlag == 1;
                            });
                            if (oldDefaultSecondGroup.length > 0) {
                                oldDefaultSecondGroup[0].defaultSecondFlag = 0;
                            }
                            targetUserTalkGroup.defaultSecondFlag = 1;
                            self.defaultSecondGroup.tenantId = targetUserTalkGroup.tenantId;
                            self.defaultSecondGroup.talkGroupId = targetUserTalkGroup.talkgroupId;
                            commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_change_default_second_group"), 4000);
                            return;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                            break;
                        case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted_talkgroup"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeDefaultSecondGroup2").replace("{code}",res.data.status));
                            break;
                    }
                    this.redrawDefaultSecondGroup();
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "changeDefaultSecondGroup", error);
                });
            }
        },
        changeVoiceReportGroup(targetUserTalkGroup) {
            let self = this;
            if ((targetUserTalkGroup.optionFlag & (1 << constants.TALKGROUP_OPTION_FLAG_LONG_TALKGROUP)) !== 0) {
                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_setting_a_long_talk_group_as_a_safety_group"));
                return;
            }

            let parameter = { operation:
                    {
                        tenantId: targetUserTalkGroup.tenantId,
                        talkgroupId: targetUserTalkGroup.talkgroupId,
                        userTenantId: targetUserTalkGroup.userTenantId,
                        id: this.userAttribute.id
                    }
            };
            if (targetUserTalkGroup.voiceReportFlag == 1) {
                server.post("/resetvoicereportgroup", parameter)
                    .then((res) => {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS:
                                targetUserTalkGroup.voiceReportFlag = 0;
                                commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_reset_voice_report_group"), 4000);
                                return;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeVoiceReportGroupOff").replace("{code}",res.data.status));
                                break;
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "changeVoiceReportGroupOff", error);
                    });
            } else {
                server.post("/setvoicereportgroup", parameter)
                    .then((res) => {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS:
                                let previousVoiceReportGroup = self.talkGroupUsers.filter(function(userTalkGroup) {
                                    return userTalkGroup.voiceReportFlag === 1;
                                });
                                if (previousVoiceReportGroup.length > 0) {
                                    // unflag previous
                                    previousVoiceReportGroup[0].voiceReportFlag = 0;
                                }
                                targetUserTalkGroup.voiceReportFlag = 1;
                                commonUtil.notifyMessageWithDuration(self,"Success",commonUtil.getMessageText(self.$i18n,"info_change_voice_report_group"), 4000);
                                return;
                            case constants.STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT_LINKED_TENANT:
                                commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "error_cannot_modify_user_insufficient_license_linked_tenant"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","changeVoiceReportGroupOn").replace("{code}",res.data.status));
                                break;
                        }
                        this.redrawVoiceReportGroup();
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "changeVoiceReportGroupOn", error);
                    });
            }
        },
        updateTalkgroupUsersAfterDisappearDialog(input) {
            // dialog will not be disappeared immediately when a lot of users in the tenant
            // update talkGroup users after disappear(DOM element of dialog not found) the dialog
            this.showAddTalkGroupToUser=false;
            let self = this;
            let timer = setInterval(
                function() {
                    if (document.getElementById("addTalkgroupToUser") == null) {
                        clearInterval(timer);
                        self.closeLoadingScreen();
                        self.updateTalkgroupUsers(input);
                    }
                }
            ,100);
        },
        updateTwoPhaseMethod(input, method) {
            let self = this;
            server.post('/settwophasemethod', input)
                .then((res) => {
                    this.showEditTwoPhaseMethod = false;
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self,"Success", commonUtil.getMessageText(self.$i18n,"info_change_two_phase_method").replace("{method}", method));
                            self.getInfo();
                            break;
                        case constants.STATUS_ERROR_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_no_user_information"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error", commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","updateTwoPhaseMethod").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "updateTwoPhaseMethod", error);
                });
        },
        updateTalkgroupUsers(input) {
            this.showAddTalkGroupToUser=false;
            let operations = [];

            // create addtotalkgroup request parameter
            for (let key in input.addTagList) {
                let tag = input.addTagList[key]
                operations.push({
                     command: "addtotalkgroup",
                     operation: {
                         tenantId: tag.tenantId,
                         talkgroupId: tag.talkgroupId,
                         userTenantId: this.appData.tenantList[0].tenantId,
                         userId: this.userAttribute.id
                     }
                 })
            }

            // create removefromtalkgroup request parameter
            for (let key in input.removeTagList) {
                let tag = input.removeTagList[key]
                operations.push({
                    command: "removefromtalkgroup",
                    operation: {
                        tenantId: tag.tenantId,
                        talkgroupId: tag.talkgroupId,
                        userTenantId: this.appData.tenantList[0].tenantId,
                        userId: this.userAttribute.id
                    }
                })
            }

            let self = this;

            if (operations.length == 0) {
                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_no_changing_information"));
                return;
            }

            server.post('/multiop', {operations: operations})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.getUserTalkGroupInfo({type: "Success", text:commonUtil.getMessageText(self.$i18n,"info_modified_participant_group_of_user")});
                            if (self.tableView) {
                                self.$emit('refresh');
                            }
                            break;
                        case constants.STATUS_ERROR_BATCH_PROCESS:
                            if (res.data.errorInfo.length > 0 && res.data.errorInfo[0].errorCode === constants.STATUS_ERROR_EXCEEDS_MAX_COUNT) {
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_in_alert_group_for_exceed"));
                                break;
                            }
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_participated_group_access_denied"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","updateTalkgroupUsers").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "updateTalkgroupUsers", error);
                });
        },
        filterTalkGroup() {
            let param = { id: this.userAttribute.id };
            if (this.condition == "name") {
                if (this.searchString != "") {
                    param.searchName = this.searchString;
                } else {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(self.$i18n,"error_input_search_condition"));
                    return;
                }
            } else if (this.condition == "mandatoryYes") {
                param.searchMandatory = true;
            } else if (this.condition == "mandatoryNo") {
                param.searchMandatory = false;
            } else {
                if (this.condition == "all") {
                    this.searchString = "";
                    this.getUserTalkGroupInfo(null);
                }
            }
            let self = this;
            self.talkGroupUsers = [];
            server.post('/getusertalkgroupinfo', param)
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.usersTalkGroupExceededMax = false;
                            break;
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            self.usersTalkGroupExceededMax = true;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","filterTalkGroup").replace("{code}",res.data.status));
                            return;
                    }
                    if (res.data.userTalkgroup.length == 0) {
                        commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_group_not_found"));
                        return;
                    }
                    let result = commonUtil.sortUserTalkGroup(self.appData, res.data.userTalkgroup, constants.OBJECT_TALKGROUP)
                    self.talkGroupUsers = result.sortedUserTalkGroup;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "filterTalkGroup", error);
                });
        },
        clearSearchString() {
            this.searchString = "";
        },
        removeTalkGroup: function(index) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            if (this.talkGroupUsers[index].tenantId != this.appData.tenantList[0].tenantId) {
                let externalGroup = false;
                for (let exportedTenant of this.appData.exportedTenantList) {
                    if (exportedTenant.tenantId == this.talkGroupUsers[index].tenantId) {
                        externalGroup = true;
                        break;
                    }
                }
                if (externalGroup) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_remove_group_by_link"));
                    return;
                }
            }
            this.removeTalkGroupIndex = index;
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"title_userGroup");
            this.confirmInfo.objectName = this.talkGroupUsers[index].talkgroupName;
            this.$data.showDeleteTalkGroup = true;
        },
        removeFromTalkGroup: function() {
            this.showDeleteTalkGroup = false;
            let self = this;
            server.post(
                '/removefromtalkgroup',
                {
                    operation:
                    {
                        tenantId: this.talkGroupUsers[this.removeTalkGroupIndex].tenantId ,
                        talkgroupId: this.talkGroupUsers[this.removeTalkGroupIndex].talkgroupId ,
                        userTenantId: this.talkGroupUsers[this.removeTalkGroupIndex].userTenantId ,
                        userId: this.userAttribute.id
                    }
                }
            ).then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.talkGroupUsers.splice(self.removeTalkGroupIndex,1);
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_deleted_groupOfUser"));
                        if (self.tableView) {
                            self.$emit('refresh');
                        }
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_participated_group_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","removeFromTalkGroup").replace("{code}",res.data.status));
                        break;
                }
                self.getInfo();
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "removeFromTalkGroup", error);
            });
        },
        showDialogAfterWritableCheck(functionName) {
            const definitionActions = ['EditUser', 'DeleteUser', 'MoveUser', 'EditTwoPhaseMethod'];
            if (definitionActions.includes(functionName) && !commonUtil.canManageConsoleUserGroupDefinition(this.appData)) {
                return;
            }
            if (functionName == 'AddTalkGroupToUser' && !commonUtil.canManageConsoleUserTalkgroupAssignment(this.appData)) {
                return;
            }
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            if (functionName == 'DeleteUser') {
                if (this.userAttribute.rights != null && this.userAttribute.rights.indexOf('tenantadmin') >= 0) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_delete_user_tenant_admin"));
                    return;
                }
            }
            const parentId = this.selectedNode?.node?.parent?.data?.id;
            if (parentId == null) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(this.$i18n,"item_user")));
                return;
            }
            let self = this;
            server.post('/getinfo', {tenantId: this.appData.tenantList[0].tenantId, id: parentId })
                .then((res) => {
                    if(res.data.status == constants.STATUS_SUCCESS) {
                        let myAclId = self.appData.tenantList[0].tenantId + "-" + self.appData.loginUserObjectId;
                        let acl = JSON.parse(res.data.acl)
                        if (acl.rw != null) {
                            let writable = acl.rw.find(function(element) {
                                return element == myAclId;
                            });
                            if (writable == null) {
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_have_write_permission_on_layer").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_user")));
                            } else {
                                switch(functionName) {
                                    case "AddTalkGroupToUser":
                                        self.showAddTalkGroupToUser = true;
                                        break;
                                    case "EditUser":
                                        self.showEditUser = true;
                                        break;
                                    case "DeleteUser":
                                        self.deleteConfirmUser();
                                        break;
                                    case "MoveUser":
                                        self.showMoveUser = true;
                                        break;
                                    case "EditTwoPhaseMethod":
                                        self.showEditTwoPhaseMethod = true;
                                        break;
                                }
                            }
                        } else {
                            // no writable acl info
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_user_access_denied"));
                        }
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","showDialogAfterWritableCheck").replace("{code}",res.data.status));
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "showDialogAfterWritableCheck", error);
                });
        },
        handleChangeMandatory(talkgroupUser) {
            if (!this.showEditUserGroupCommand) {
                return;
            }
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            this.showLoadingScreen();
            let operations = [];
            let newFlag = 1;
            if (talkgroupUser.mandatoryFlag) {
                newFlag = 0;
            }
            let param = {
               tenantId: talkgroupUser.tenantId,
               talkgroupId: talkgroupUser.talkgroupId,
               userTenantId: this.appData.tenantList[0].tenantId,
               userId: this.userAttribute.id,
               newFlag: newFlag
            }
            let self = this;
            server.post('/setmandatorygroupuser', {operation: param}
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.closeLoadingScreen();
                        talkgroupUser.mandatoryFlag = newFlag;
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_mandatory_changed"));
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MANDATORY_LIMIT:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_mandatory_group_exceeded"));
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_mandatory_access_denied").replace("{object}",commonUtil.getMessageText(self.$i18n,"item_user")));
                        break;
                    case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted_talkgroup"));
                        break;
                    case constants.STATUS_ERROR_OPTION_UNMATCH:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_mandatory_group_on_alert_group"));
                        break;
                    default:
                        self.closeLoadingScreen();
                        commonUtil.notifyMessage(self,"Error", commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleChangeMandatory").replace("{code}",res.data.status));
                        break;
                }
                return;
            })
            .catch( function ( error ) {
                self.closeLoadingScreen();
                commonUtil.putExceptionErrorMessage(self, "handleMandatoryChange", error);
            });
        },
        handleChangeSearchCondition() {
            if ((this.condition == "mandatoryYes") || ((this.condition == "mandatoryNo"))) {
                this.filterTalkGroup();
            }
            if (this.condition == "all") {
                this.getUserTalkGroupInfo(null);
            }
        },
        setUserOptions: function(onlinePurchase) {
            let userOptions;
            if (onlinePurchase) {
                userOptions = commonUtil.getUserOptionForOnline(this.$i18n);
            } else {
                userOptions = commonUtil.getUserOption(this.$i18n);
            }

            this.userOptions = [];
            for (var i = 0 ; i < userOptions.length ; i++ ) {
                this.userOptions.push({displayName: userOptions[i].name, shift: userOptions[i].shift, value: false});
            }
        },
        handleChangeTab() {
            if (this.selectedTabName == "userGroup") {
                this.getUserTalkGroupInfo(null);
            }
            this.reDrawTab();
        },
        beforeLeave(activeName, oldActiveName) {
            if (activeName == "userGroup") {
                this.showLoadingScreen();
            }
            return true;
        },
        showLoadingScreen() {
            if (this.loadingScreen == null) {
                this.loadingScreen = this.$loading({
                        lock: true ,
                        text: 'Loading data ...' ,
                        spinner: 'el-icon-loading' ,
                        background: 'rgba(0, 0, 0, 0)'
                });
            }
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        reDrawTab() {
            // some of message of old tab was remained in new tab.
            // it can clear by redraw
            this.showTab = false;
            this.$nextTick(() => {
                 this.showTab = true
            })
        },
        redrawDefaultGroup() {
            // reset displayed default flag by reDraw
            this.showDefaultGroup = false;
            this.$nextTick(() => {
                 this.showDefaultGroup = true
            })
        },
        redrawDefaultSecondGroup() {
            // reset displayed default second flag by reDraw
            this.showDefaultSecondGroup = false;
//            this.showDefaultSecondGroup = true;
            this.$nextTick(() => {
                 this.showDefaultSecondGroup = true
            })
        },
        redrawVoiceReportGroup() {
            // reset displayed voice report group flag by reDraw
            this.showVoiceReportGroup = false;
            this.$nextTick(() => {
                this.showVoiceReportGroup = true
            })
        },
        isVisibleUserOption(optionName) {
            if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
                return commonUtil.isVisibleUserOption(this.appData.onlinePurchase, optionName);
            } else {
                return true;
            }
        },
        isTwoPhaseMethodActive() {
            return this.appData.twoPhaseMethod;
        },
        isUserTwoPhaseMethodReady() {
            let userAttribute = this.userAttribute;
            if (userAttribute == null) {
                return false;
            }
            if (!('twoPhaseMethod' in userAttribute)) {
                return false;
            }
            if (userAttribute.twoPhaseMethod.length == 0) {
                return false;
            }
            return true;
        },
        getMessageText(messageId) {
            return commonUtil.getMessageText(this.$i18n, messageId);
        },
        showTwoPhaseMethod(twoPhaseMethod) {
            let methodAndTarget = twoPhaseMethod.split(':');
            let shownName;
            let shownTarget;
            let result;
            switch (methodAndTarget.length) {
                case 1:
                    if (twoPhaseMethod == "TENANT_TOTP") {
                        return this.getMessageText("info_two_phase_method_show_console");
                    }
                    shownName = this.userAttribute.name + ' / ' + this.userAttribute.displayName;
                    shownTarget = this.getMessageText("item_two_phase_method_info").replace("{target}", shownName)
                    result = methodAndTarget[0] + ': ' + shownTarget;
                    return result;
                case 2:
                    return twoPhaseMethod;
                case 3:
                    shownName = methodAndTarget[2];
                    shownTarget = this.getMessageText("item_two_phase_method_info").replace("{target}", shownName)
                    result = methodAndTarget[0] + ': ' + shownTarget;
                    return result;
            }
        },
    }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li {
  list-style:none;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
}
.modal-default-button {
  float: right;
}

input[type="radio"]{
    outline: 0;
     -webkit-appearance: none;
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(../../../../assets/icon_check_gray.svg);
}
input[type="radio"]:checked {
    outline: 0;
    width: 20px;
    height: 20px;
    background: url(../../../../assets/icon_check_green.svg);
}
input[type="radio"]:hover {
     cursor : pointer;
}
.talkgroup-title {
    width: 100%;
    padding: 10px 0 10px 28px;
    display: table-row;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
}
.talkgroup-item-header1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.talkgroup-item-header2 {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 15%;
    text-align:center;
}
.talkgroup-item-record {
    border-bottom:1px #eee solid;
}
.talkgroup-item-record:hover {
    background-color: #ecf1fa;
}
.talkgroup-item1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 28px;
    font-size: 14px;
}
.talkgroup-item2 {
    text-align: center;
}

.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.custom-checkbox-input {
  display: none;
}

.action-radio-input:disabled:hover {
    cursor: not-allowed;
}

.action-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.action-icon-disabled {
    cursor: not-allowed;
}

.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb;
    opacity: 0.7;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #848991;
    background: #f6f6f6;
    border: none;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item {
    color: #5171cb;
    background: #ecf1fa;
}
.el-tabs__nav-scroll {
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__header {
    border: none;
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__content {
    padding: 0px;
}
.el-tabs--border-card {
    border: none;
}
</style>
